import { registerQuery } from 'data-fetching-client';
import { purchaseMotionsGetRpc } from 'growth-monetization-service-types';
import { rpcClient } from '../client';
export const fetchPurchaseMotions = ({
  locations,
  apiNames
}) => rpcClient.call(purchaseMotionsGetRpc, {
  queryParameters: {
    location: locations,
    apiName: apiNames
  }
});
export const PURCHASE_MOTION_QUERY = registerQuery({
  fieldName: 'purchaseMotions',
  args: ['locations', 'apiNames'],
  fetcher: fetchPurchaseMotions
});